import * as _ from 'lodash';
import { AxiosRequestConfig } from 'axios';
import { client } from '../http';

function init() {
  function addTokenToRequests(config: AxiosRequestConfig) {
    // eslint-disable-next-line
    config.headers = _.extend({}, config.headers, { 'COMMIT-HASH': import.meta.env.__COMMIT_HASH__ });

    return config;
  }

  client.interceptors.request.use(addTokenToRequests);
}

export default {
  init,
};
